import * as redeService from '@/store/rede/services'
import * as corpoClinicoService from '@/store/corpoClinico/services'
import to from 'await-to-js'

export const state = {
  idRede: null,
  codigoEspecialidade: null,
  especialidade: null,
  servico: null,
  consulta: null,
  redeSingle: null,
  profissionais: [],
  exames: [],
  exameParams: [],
  subTotalParticular: 0,
  subTotalDrAchei: 0,
  subTotalSinSaude: 0,
  idConsulta: null
}

export const getters = {
  idRede: state => state.idRede,
  codigoEspecialidade: state => state.codigoEspecialidade,
  especialidade: state => state.especialidade,
  servico: state => state.servico,
  consulta: state => state.consulta,
  redeSingle: state => state.redeSingle,
  profissionais: state => state.profissionais,
  exameParams: state => state.exameParams,
  exames: state => state.exames,
  subTotalParticular: state => state.subTotalParticular,
  subTotalDrAchei: state => state.subTotalDrAchei,
  subTotalSinSaude: state => state.subTotalSinSaude,
  idConsulta: state => state.idConsulta
}

export const mutations = {
  setIdRede (state, payload) {
    state.idRede = payload
  },
  setCodigoEspecialidade (state, payload) {
    state.codigoEspecialidade = payload
  },
  setEspecialidadeSingle (state, payload) {
    state.especialidade = payload
  },
  setServico (state, payload) {
    state.servico = payload
  },
  setConsulta (state, payload) {
    state.consulta = payload
  },
  setRedeSingle (state, payload) {
    state.redeSingle = payload
  },
  setProfissionais (state, payload) {
    state.profissionais = payload
  },
  setExameParams (state, payload) {
    state.exameParams = payload
  },
  setExames (state, payload) {
    state.exames = payload
  },
  setSubTotalSinSaude (state, payload) {
    state.subTotalSinSaude = payload
  },
  setSubTotalParticular (state, payload) {
    state.subTotalParticular = payload
  },
  setSubTotalDrAchei (state, payload) {
    state.subTotalDrAchei = payload
  },
  setIdConsulta (state, payload) {
    state.idConsulta = payload
  }
}

export const actions = {
  async setSingleRede ({getters, commit, dispatch}, payload) {
    commit('setIdRede', payload.idRede)
    commit('setCodigoEspecialidade', payload.especialidade)
    commit('setServico', payload.servico)
    commit('setExameParams', payload.exames)
    commit('setIdConsulta', payload.consulta)

    dispatch('setLoading', true)
    const [error, response = {data: null}] = await to(redeService.getRede(getters.idRede))
    if (error) {
      dispatch('setLoading', false)
      throw error
    }
    commit('setRedeSingle', response.data)

    const [errorProfissionais, responseProfissionais = {data: []}] = await to(corpoClinicoService.listProfissionaisAtivos(getters.idRede))
    if (errorProfissionais) {
      dispatch('setLoading', false)
      throw error
    }
    commit('setProfissionais', responseProfissionais.data)

    if (getters.servico === 'Consulta') {
      commit('setProfissionais', responseProfissionais.data.filter(profissional => profissional.especialidade._id === parseInt(getters.codigoEspecialidade, 10)))
      const [errorConsulta, responseConsulta = {data: null}] = await to(redeService.getConsulta(getters.idConsulta))
      if (errorConsulta) {
        dispatch('setLoading', false)
        throw error
      }
      commit('setConsulta', responseConsulta.data)
      commit('setEspecialidadeSingle', getters.consulta.especialidade)
    } else if (getters.servico === 'Exame') {
      const [errorExame, responseExame = {data: null}] = await to(redeService.getExames(getters.idRede, getters.exameParams))
      if (errorExame) {
        dispatch('setLoading', false)
        throw error
      }
      dispatch('setLoading', false)

      const exames = responseExame.data
      commit('setExames', exames)

      commit('setSubTotalDrAchei', exames.map(exame => exame.valorDrAchei).reduce((a, value) => a + value, 0))
      commit('setSubTotalSinSaude', exames.map(exame => exame.valorSinSaude).reduce((a, value) => a + value, 0))
      commit('setSubTotalParticular', exames.map(exame => exame.valorParticular).reduce((a, value) => a + value, 0))
      return responseExame.data
    }

    dispatch('setLoading', false)

    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/singleRede/index.js